<script>
import ListingModel from "@/views/Training/TrainingSession/Components/ListingModel.vue";

export default {
    name: "HotEvaluations",
    components: {ListingModel}
}
</script>

<template>
    <ListingModel type="HOT"/>
</template>